"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var LoadingBone = function LoadingBone(props) {
  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.6 42.79"
  }, props), _react.default.createElement("title", null, "bone"), _react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _react.default.createElement("g", {
    id: "props"
  }, _react.default.createElement("path", {
    d: "M111.71,21.4A11.67,11.67,0,0,0,116.6,12c0-6.65-5.88-12-13.13-12C97.67,0,94.16,3.44,93,8.22H23.62C22.44,3.44,18.93,0,13.13,0,5.88,0,0,5.39,0,12A11.67,11.67,0,0,0,4.89,21.4,11.65,11.65,0,0,0,0,30.76c0,6.65,5.88,12,13.13,12,6.23,0,9.83-4,10.72-9.31h68.9c.89,5.33,4.49,9.31,10.72,9.31,7.25,0,13.13-5.38,13.13-12A11.65,11.65,0,0,0,111.71,21.4Z",
    fill: "#e3dfd3"
  }))));
};

var _default = LoadingBone;
exports.default = _default;